/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboards_Chart_ErrorInputs */



/**
* | output |
* | --- |
* | "This chart's query failed" |
*
* @param {Dashboards_Chart_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboards_chart_error = /** @type {((inputs?: Dashboards_Chart_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboards_Chart_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Abfrage dieses Diagramms ist fehlgeschlagen")
	return /** @type {LocalizedString} */ ("This chart's query failed")
});